module.exports = "/images/vendor/flag-icon-css/flags/4x3/ke.svg?dd8a91b8196000643e3383d81c659ecb";